
export function ArrowIcon(props: {
  color?: string;
  w?: number;
  h?: number;
  borderW?: number;
}) {
  const color = props.color ?? "white";
  const width = props.w ?? 8;
  const height = props.w ?? 8;
  const borderW = props.borderW ?? 8;
  return (
    <div
      style={{
        display: "block",
        width,
        height,
        borderLeft: `${borderW}px solid ${color}`,
        borderBottom: `${borderW}px solid ${color}`,
        transform: "rotate(-45deg)",
        marginTop: "-2px",
      }}
    ></div>
  );
}
